import { ApiClient, ApiClientProps, Paginated } from './client';

export type OrganizationInvite = {
  id: number;
  email: string;
  role: string;
  status: string;
  is_expired: boolean;
  invited_by_name: string | null;
  created_at: string;
  expires_at: string;
};

export type InviteCreateRequest = {
  emails: string[];
  role: string;
};

export type InviteCreateResponse = {
  sent: OrganizationInvite[];
  skipped: { email: string; reason: string }[];
};

export type InvitePublicDetail = {
  organization_name: string;
  email: string;
  role: string;
  status: string;
  is_expired: boolean;
};

export type InviteAcceptResponse = {
  detail: string;
  organization_id: number;
  team_id: number;
};

export class OrganizationInvitesClient extends ApiClient {
  constructor(props: ApiClientProps) {
    super(props);
  }

  create = async (orgId: number, data: InviteCreateRequest) => {
    return this._post<InviteCreateResponse>(`organizations/${orgId}/invites/`, data);
  };

  list = async (orgId: number) => {
    return this._get<Paginated<OrganizationInvite>>(`organizations/${orgId}/invites/`);
  };

  revoke = async (orgId: number, inviteId: number) => {
    return this._delete(`organizations/${orgId}/invites/${inviteId}/`);
  };

  resend = async (orgId: number, inviteId: number) => {
    return this._post<OrganizationInvite>(`organizations/${orgId}/invites/${inviteId}/resend/`);
  };

  getByToken = async (token: string) => {
    return this._get<InvitePublicDetail>(`invites/${token}/`);
  };

  accept = async (token: string) => {
    return this._post<InviteAcceptResponse>(`invites/${token}/accept/`);
  };

  decline = async (token: string) => {
    return this._post<{ detail: string }>(`invites/${token}/decline/`);
  };
}
